import React from 'react'
import { PageHeader } from 'antd'
import openNotificationWithIcon from 'helpers/notification'
import Letterhead from './Letterhead'


const Settings = (props) => {

    const { state } = props.location   
    if(state && state.message){                           
        openNotificationWithIcon(state.type, 'Pengaturan', state.message)    
        props.history.replace({ ...props.location.pathname, state: null })
    }

    return(
        <div className="site-layout-background" style={{ padding: 10, minHeight: 360 }}>
            <PageHeader
                className="site-page-header "
                onBack={() => null}
                backIcon={null}
                title="Pengaturan"
                // subTitle="Atur"
            />

            {/* <Tabs defaultActiveKey={state ? state.tabKey || "1" : "1"} type="card">
                <Tabs.TabPane tab={<span><HighlightOutlined /> Signature</span>} key="1">
                    <Signatures {...props} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span><SnippetsOutlined /> Kop Surat</span>} key="2">
                   
                </Tabs.TabPane>
            </Tabs>    */}
             <Letterhead {...props} />
        </div>
    )
}

export default Settings